export default __webpack_public_path__ + "static/media/rec_prod.5d28ccd2.png";